import React, { useState } from 'react';

const FallbackImage = ({ 
  src, 
  alt, 
  className = "", 
  fallbackSrc = null,
  showPlaceholder = true,
  placeholderText = "Image Coming Soon",
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleImageError = () => {
    setImageError(true);
    setIsLoading(false);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  // If there's an error and no fallback, show placeholder
  if (imageError && !fallbackSrc) {
    if (!showPlaceholder) return null;
    
    return (
      <div 
        className={`flex items-center justify-center bg-gradient-to-br from-[#F3F4F6] to-[#e5e7eb] text-[#0B1E2B] ${className}`}
        {...props}
      >
        <div className="text-center p-4">
          <div className="text-4xl mb-2">🍎</div>
          <div className="text-sm font-medium">{placeholderText}</div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isLoading && showPlaceholder && (
        <div 
          className={`flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 text-gray-600 ${className}`}
          {...props}
        >
          <div className="text-center p-4">
            <div className="animate-spin text-2xl mb-2">⏳</div>
            <div className="text-sm">Loading...</div>
          </div>
        </div>
      )}
      <img
        src={imageError && fallbackSrc ? fallbackSrc : src}
        alt={alt}
        className={`${className} ${isLoading ? 'hidden' : ''}`}
        onError={handleImageError}
        onLoad={handleImageLoad}
        {...props}
      />
    </>
  );
};

export default FallbackImage;
